module.exports = __webpack_public_path__ + "img/canvasMenuQuickStyle.8c578790.svg";